import { Backend } from '@/_axios';

export default {
  list(projectId, params) {
    return Backend.get(`/project/${projectId}/label_sets/`, { params, cancelDuplicates: true });
  },
  sampleList(projectId, labelSetId, params) {
    return Backend.post(`/project/${projectId}/label_sets/${labelSetId}/samples`, { ...params });
  },
  createData(projectId) {
    return Backend.get(`/project/${projectId}/label_sets/create`);
  },
  editData(projectId, id) {
    return Backend.get(`/project/${projectId}/label_sets/${id}/edit`);
  },
  create(projectId, data) {
    return Backend.post(`/project/${projectId}/label_sets/`, data);
  },
  update(projectId, data) {
    return Backend.put(`/project/${projectId}/label_sets/${data.id}`, data);
  },
  delete(projectId, id) {
    return Backend.delete(`/project/${projectId}/label_sets/${id}`);
  },
  deleteLabelSetSample(projectId, id, sampleSetId) {
    return Backend.delete(`/project/${projectId}/label_sets/${id}/sample_set/${sampleSetId}`);
  },
  applyTags(projectId, labelSetId, data) {
    return Backend.post(`/project/${projectId}/label_sets/${labelSetId}/apply_tags`, data);
  },
  setVerifiedSamples(projectId, labelSetId, data) {
    return Backend.post(`/project/${projectId}/label_sets/${labelSetId}/set_verified_samples`, data);
  },
  downloadLabelSet(projectId, labelSetId) {
    return Backend.get(`/project/${projectId}/label_sets/${labelSetId}/get_label_set`);
  },

};
